/**************************************************
 * Nombre:       Seccion_Colecciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import Colecciones_Lista from "./Componentes/Colecciones_Lista";
import Home_Categorias from "./Componentes/Home_Categorias";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {collection, query, where} from "firebase/firestore";
import {SECCIONES} from "../../Constantes";
import {irArriba} from "../../Utilidades/irArriba";
import {fire} from "../../fire";


const Seccion_Colecciones = () => {
    const {sCell} = useResponsive()
    const [colecciones, setColecciones] = useState([])

    useEffect(() => {
        irArriba()
        let w = [where('estado', '==', 'Publicada')]

        obtenerColWheres({col: 'colecciones', wheres: w}).then((dox) => {
            setColecciones(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: sCell ? 4 : 8}}>
                <Typography
                    sx={{
                        color: theme.palette.primary.main,
                        fontSize: sCell ? 20 : 30,
                        fontWeight: 400
                    }}>COLECCIONES</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Colecciones_Lista items={colecciones} />
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 12, mb: 12}}>
                <Home_Categorias/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Colecciones